export default __webpack_public_path__ + "static/2.7dd9c4e5875ac4afdb0acdf703a24c40.png";